module.exports = __webpack_public_path__ + "img/logo.058b28df.png";